import {
  ACCOUNT_TYPE_LABEL_JA,
  BANK_TYPE_LABEL_JA,
  type AccountTypeCode,
  type BankTypeCode,
} from './bankAccountDetailsTypes';

export function formatYesNo(t: (k: string) => string, v: string): string {
  const s = v.trim().toLowerCase();
  if (s === 'true' || s === 'yes') return t('submitDocuments.bankAccountDetails.yes');
  if (s === 'false' || s === 'no') return t('submitDocuments.bankAccountDetails.no');
  return v;
}

export function formatBankType(v: string): string {
  const s = v.trim().toLowerCase() as BankTypeCode;
  return BANK_TYPE_LABEL_JA[s] ?? v;
}

export function formatAccountType(v: string): string {
  const s = v.trim().toLowerCase() as AccountTypeCode;
  return ACCOUNT_TYPE_LABEL_JA[s] ?? v;
}

